module.exports = __webpack_public_path__ + "media/images/icons/icn_038-42e3761140af66ccc3aad0c0e63b171f.svg";